export default "__VITE_ASSET__BV9IqtJN__"